import {BaseComponent} from "./base.component";
import {BreadcrumbItem, Layout} from "../../modules/common/modules/generic/breadcrumb/breadcrumb.model";
import {EventBusService} from "../services/eventbus/event-bus.service";
import {Router} from "@angular/router";
import {SubscriptionContainerService} from "../services/subscription-container.service";
import {ComponentType} from "@angular/cdk/overlay";
import {BaseConfig} from "../models/baseConfig";
import {Component} from "@angular/core";
import {StringUtil} from "../../utils/string.util";
import {DialogService} from "../../modules/common/modules/utility/components/popup/dialog.service";
import {BaseUpsertComponentV2} from "./base-upsert-v2.component";
import {slideIn} from "../animations/component.animation";
import {IParams} from "../endpoints/iparams";
import {LocalStorageService} from "../services/storage/localstorage.service";

@Component({
  template: '',
  animations: [
    slideIn('onGrid', 'left'),
    slideIn('onColumn', 'right')
  ]
})
export abstract class BaseListComponentV2<MODEL> extends BaseComponent {
  protected readonly Layout = Layout;
  protected readonly StringUtil = StringUtil;

  protected breadcrumbItems: BreadcrumbItem[] = []
  protected layout: Layout = Layout.GRID

  protected constructor(
    eventBus: EventBusService,
    router: Router,
    subContainer: SubscriptionContainerService,
    private popup: DialogService<MODEL>,
  ) {
    super(eventBus, router, subContainer);
    this.breadcrumbItems = this.getBreadcrumbItems();
  }

  override ngOnInit() {
    let key = this.getConfig().searchEndpoint
    let layout = LocalStorageService.retrieve(key)
    if (layout != null) {
      this.layout = parseInt(layout)
    } else {
      this.layout = this.getConfig().defaultLayout
    }

    this.initialize()
  }

  protected abstract initialize(): void

  protected abstract getBreadcrumbItems(): BreadcrumbItem[];

  abstract getUpsertComponent(): ComponentType<BaseUpsertComponentV2<MODEL>> | null;

  abstract getConfig(): BaseConfig

  abstract getRoutes(): { create: string, update: (id: number) => string, params: IParams } | null

  onLayoutSelected(layout: Layout) {
    this.layout = layout
    LocalStorageService.put(this.getConfig().searchEndpoint, this.layout.toString())
  }

  openUpsertComponent(id: number | null) {
    let upsertComponent = this.getUpsertComponent()
    if (upsertComponent == null) {
      return
    }
    this.popup.open(upsertComponent, {id: id})
    this.popup.onCompleted.subscribe((result: MODEL | null) => {
      this.ngOnInit()
      if (result != null) {
        this.onUpsertSuccess(result)
      }
      console.log("onSuccess. closing dialog")
    })
    this.popup.onCanceled.subscribe(() => {
      console.log("onCanceled. closing dialog")
    })
  }

  onUpsertClick(id: number | null) {
    if (this.getConfig().upsertOnDialog) {
      this.openUpsertComponent(id)
    } else {
      let routes = this.getRoutes()
      if (routes == null) {
        return
      }
      let route = id == null ? routes.create : routes.update(id)
      this.router.navigate([route], {queryParams: id != null ? routes.params : {}})
    }
  }

  protected onUpsertSuccess(result: MODEL) {
    console.log("onUpsertSuccess", result)
    // kept empty for override
  }
}
